<template>
  <div class="l-learn-follow-read" v-if="element">
    <!-- 视频讲解 -->
    <LLearnVideo ref="LLearnVideo" v-if="isVideoExplain" class="follow-read-vedio" :options="{
        vid: vid,
        autoplay: false,
        hidePlayBtn: true,
        canstop: false,
      }" @play="onPlay" @leavingFull="leavingFull" />
    <!-- 录音回答 -->
    <div class="lSoundRecording-btn">
      <lRecorder ref="recorder" v-show="status === 1" :options="recorderOptions" :btn-text="btnName" @result="onresult"
        @start="onstart" @init="onRecordInit" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import version from '@/utils/version'
import UPModel from '@/models/imgup'
import LLearnVideo from '../l-learn-video'
import lRecorder from '../../components/l-recorder'
const { mapGetters, mapActions } = createNamespacedHelpers('course')

const up = new UPModel()

export default {
  components: { LLearnVideo, lRecorder },
  data() {
    return {
      vid: '', //视频id
      isVideoExplain: false, //视频
      currentTestItem: {}, //当前元素的数据
      audioData: '', //录音数据
      status: 0, //0不能点击,1可以录音,2录音中,3录音结束
      btnName: '点击按钮开始跟读',
      recordingIsClick: false, //录音时只能倒计时完成提交
      stage: 'isInit', //当前跟读元素的状态
      stageStatus: {
        isInit: 'isInit',
        isReady: 'isReady',
        isRecording: 'isRecording',
      },
      recorderOptions: {
        elementType: null,
        duration: null,
        keywords: '',
        text: '',
      },
      maxDuration: 170, // 最长录音时间
    }
  },
  computed: {
    ...mapGetters(['element']),
  },
  watch: {
    'element.ELEMENT_TYPE'(to) {
      if (to) {
        // 跟读 大情景段跟读
        this.currentTestItem = this.element
        this.vid = this.currentTestItem.attrs.videoId //不同元素这里的获取的字段不一样
        if (this.currentTestItem) {
          this.isVideoExplain = true
        }

        // 录音参数
        this.recorderOptions.elementType = this.element.type
        this.recorderOptions.text = this.element.attrs.videoDesc
        this.onGetPlayerParams(this.element.attrs.videoId)
        this.recorderOptions.audioFileName = `${this.element.RECORD_ID}`
      }
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    // 录音初始化成功
    onRecordInit() {
      this.isRealEnd = false
      // 提示带耳机，并主动触发开始
      this.$lPrompt({
        message: '您确定耳机状态已保持正常请开始闯关',
        successTxt: this.$locale.去闯关,
        successFn: () => {
          this.$refs.recorder.start()
        },
      })
    },
    onstart() {
      this.$refs.LLearnVideo.onPlay()
    },
    // 录音完成
    onresult(data) {
      console.log('录音结果:', data)
      this.$refs.LLearnVideo.onPlayEnd()
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: {
          eleId: this.element.id,
          ...data,
        },
      }).then(() => {
        this.$emit('next')
      })
    },
    onPlay() {
      if (version.isPC()) {
        this.$refs.LLearnVideo.onFullScreenClick()
      } else {
        this.$refs.LLearnVideo.onFullScreenClick()
      }
    },
    onPlayEnd() {
      this.$refs.LLearnVideo.onPlayEnd()
    },
    leavingFull(flag) {
      if (flag) {
        let microphoneVolume = document.querySelector('.microphoneVolume')
        if (microphoneVolume) {
          microphoneVolume.parentNode.removeChild(microphoneVolume)
        }
      } else {
        if (version.isPC()) {
          // this.$refs.lSoundRecording.setMic();
        }
      }
    },
    //获取题干视频的时间用作录音回答问题的时间
    async onGetPlayerParams(vid) {
      let { data } = await up.aliInfo({ vid })
      this.recorderOptions.duration = Math.ceil(
        data.duration || this.maxDuration
      )

      this.status = 1 //当前元素初始化完成
    },
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
